/* assets/int-creator-story.js

   INT 2026-09-12 PERF. This is the two inline <script> blocks that used to sit at the
   foot of sections/creator-collection-story.liquid, 18,492 bytes and 1,197 bytes. The
   server rebuilt them and the browser re-parsed them on every creator page view. They
   are now one file, fetched once and cached. Not one line of behaviour was changed.

   The only Liquid the code needed was the collection handle. The section still prints
   it, as JSON, in #int-creator-story-cfg, and it is read once below.

   The referral offer reveal did NOT move. It stays inline in the section because it
   must run during parse, so the offer never flashes the non-referred wording first,
   and because it carries the discount_code Liquid. Its own notes are there.

   Loaded with defer, so it runs once the DOM is complete.
   REVERT: paste this back inline and delete the three tags in the section. */
(function() {
  'use strict';

  var ICR_CFG = {};
  try {
    var __icrCfgEl = document.getElementById('int-creator-story-cfg');
    if (__icrCfgEl) ICR_CFG = JSON.parse(__icrCfgEl.textContent) || {};
  } catch (e) {}

  /* ══════════════════════════════════════════════════
     HERO VIDEO — click to play/pause with sound
     ══════════════════════════════════════════════════ */
  var videoWrap = document.getElementById('icr-hero-video-wrap');
  var video = document.getElementById('icr-hero-video');
  if (videoWrap && video) {
    videoWrap.addEventListener('click', function() {
      if (video.paused) {
        video.play();
        videoWrap.classList.add('is-playing');
        videoWrap.classList.remove('is-paused');
      } else {
        video.pause();
        videoWrap.classList.remove('is-playing');
        videoWrap.classList.add('is-paused');
      }
    });
    video.addEventListener('ended', function() {
      videoWrap.classList.remove('is-playing');
      videoWrap.classList.add('is-paused');
    });
  }

  /* ══════════════════════════════════════════════════
     CLARAXENIA SIGNATURE — reveal on scroll
     ══════════════════════════════════════════════════ */
  /* The signature now sits INSIDE the ClaraXenia unfold, so an
     IntersectionObserver can never fire for it: a closed <details> gives its
     children zero size and they never intersect. Drive the reveal from the
     fold's own `toggle` instead, and reset it on close so it replays. */
  var sigCover = document.querySelector('.icr-sig-cover');
  var sigFold  = sigCover && sigCover.closest ? sigCover.closest('details.icr-fold') : null;
  if (sigCover && sigFold) {
    sigFold.addEventListener('toggle', function () {
      sigCover.classList.remove('is-revealed');
      if (sigFold.open) {
        void sigCover.offsetWidth;           /* force a reflow so it replays */
        sigCover.classList.add('is-revealed');
      }
    });
  }

  /* INT 2026-10-06. The Find your Word button (#icr-quiz-open) is a plain link to the quiz page
     now, so it needs no script here. Record: INTENTION_Shared/HANDOVER-quiz-rebuild.md */

  /* INT 2026-09-17. The before/after slider binding that lived here is now
     assets/int-ba-slider.js, shared by every before/after slider on the site. It binds on
     [data-int-ba-slider], is idempotent and re-binds on shopify:section:load.
     Record: INTENTION_Shared/APPLIED-ba-slider-consolidation-2026-09-17.md */

  /* ══════════════════════════════════════════════════
     WORD PICKER — one vote per visitor
     ══════════════════════════════════════════════════ */
  var wordBtns = document.querySelectorAll('.icr-intention-word-btn[data-icr-word]');
  var countEl  = document.querySelector('.icr-intention-count');
  var pillsEl  = document.querySelector('.icr-shared-intentions');

  if (wordBtns.length && countEl && pillsEl) {
    var collHandle = ICR_CFG.collHandle || '';
    var storageKey = 'icr_word_counts_' + collHandle;
    var votedKey   = 'icr_voted_' + collHandle;

    var ICR_REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ICR_HEART = '<svg viewBox="0 0 24 24" fill="#00FFBF"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    function celebrateVote(btn) {
      var numEl = countEl.querySelector('span');
      if (numEl) { numEl.classList.remove('icr-count-pop'); void numEl.offsetWidth; numEl.classList.add('icr-count-pop'); }
      if (ICR_REDUCE_MOTION || !btn) return;
      var r = btn.getBoundingClientRect();
      var layer = document.createElement('div');
      layer.className = 'icr-heart-layer';
      layer.style.left = (r.left + r.width / 2) + 'px';
      layer.style.top  = (r.top + r.height / 2) + 'px';
      for (var i = 0; i < 7; i++) {
        var h = document.createElement('div');
        h.className = 'icr-heart';
        var dx = (Math.random() * 80 - 40);
        h.style.setProperty('--icr-dx', dx.toFixed(1) + 'px');
        h.style.setProperty('--icr-dx2', (dx + Math.random() * 30 - 15).toFixed(1) + 'px');
        h.style.setProperty('--icr-size', (12 + Math.random() * 12).toFixed(0) + 'px');
        h.style.setProperty('--icr-dur', (0.8 + Math.random() * 0.5).toFixed(2) + 's');
        h.style.setProperty('--icr-rot', (Math.random() * 50 - 25).toFixed(0) + 'deg');
        h.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
        h.innerHTML = ICR_HEART;
        layer.appendChild(h);
      }
      document.body.appendChild(layer);
      setTimeout(function() { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 1700);
    }

    var wordCounts = {};
    try {
      var stored = localStorage.getItem(storageKey);
      if (stored) wordCounts = JSON.parse(stored);
    } catch(e) {}

    delete wordCounts['Word'];

    var hasVoted = false;
    var votedWord = null;
    try {
      votedWord = localStorage.getItem(votedKey);
      if (votedWord) hasVoted = true;
    } catch(e) {}

    /* Generate consistent seed from word name */
    function hashSeed(str) {
      var h = 0;
      for (var i = 0; i < str.length; i++) {
        h = ((h << 5) - h) + str.charCodeAt(i);
        h = h & h;
      }
      return 150 + (Math.abs(h) % 120); /* range: 150–269 */
    }

    wordBtns.forEach(function(btn) {
      var word = btn.getAttribute('data-icr-word');
      var seed = parseInt(btn.getAttribute('data-icr-seed') || '0', 10);
      if (word && word !== 'Word') {
        var base = seed > 0 ? seed : hashSeed(word);
        // custom.popularity is the source of truth; show this visitor's own +1 if they voted
        wordCounts[word] = base + (votedWord === word ? 1 : 0);
      }
    });

    function saveCounts() {
      try { localStorage.setItem(storageKey, JSON.stringify(wordCounts)); } catch(e) {}
    }

    function updateDisplay(selectedWord) {
      var count = wordCounts[selectedWord] || 0;
      countEl.innerHTML = '<span>' + count + '</span> others are choosing ' + selectedWord + ' this month';

      var validWords = [];
      wordBtns.forEach(function(btn) {
        var w = btn.getAttribute('data-icr-word');
        if (w && w !== 'Word') validWords.push(w);
      });
      validWords.sort(function(a, b) { return (wordCounts[b] || 0) - (wordCounts[a] || 0); });

      pillsEl.innerHTML = validWords.map(function(w) {
        return '<span class="icr-shared-pill">' + w + ' <span class="icr-count-num">' + (wordCounts[w] || 0) + '</span></span>';
      }).join('');
    }

    function lockAllButtons() {
      wordBtns.forEach(function(b) { b.classList.add('icr-voted'); });
    }

    if (hasVoted && votedWord) {
      wordBtns.forEach(function(btn) {
        if (btn.getAttribute('data-icr-word') === votedWord) {
          btn.classList.add('icr-selected');
        }
      });
      lockAllButtons();
      updateDisplay(votedWord);
    } else {
      var defaultBtn = document.querySelector('.icr-intention-word-btn[data-icr-current="true"]') || wordBtns[0];
      if (defaultBtn) {
        var defaultWord = defaultBtn.getAttribute('data-icr-word');
        defaultBtn.classList.add('icr-selected');
        updateDisplay(defaultWord);
      }
    }

    var WORKER_URL = 'https://intention-votes.nils-8f9.workers.dev';

    function currentShownWord() {
      var sel = document.querySelector('.icr-intention-word-btn.icr-selected');
      return sel ? sel.getAttribute('data-icr-word')
                 : (wordBtns[0] && wordBtns[0].getAttribute('data-icr-word'));
    }

    // Pull the live shared count from the Worker and update in place
    wordBtns.forEach(function(btn) {
      var word = btn.getAttribute('data-icr-word');
      var seed = parseInt(btn.getAttribute('data-icr-seed') || '0', 10);
      if (!word || word === 'Word') return;
      fetch(WORKER_URL + '/?word=' + encodeURIComponent(word) + '&seed=' + seed)
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d && typeof d.count === 'number') {
            wordCounts[word] = d.count;
            updateDisplay(currentShownWord());
          }
        })
        .catch(function() {});
    });

    wordBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (hasVoted) return;

        var word = btn.getAttribute('data-icr-word');
        if (!word || word === 'Word') return;

        hasVoted = true;
        votedWord = word;

        wordBtns.forEach(function(b) { b.classList.remove('icr-selected'); });
        btn.classList.add('icr-selected');

        // optimistic bump so the UI reacts instantly with the hearts
        wordCounts[word] = (wordCounts[word] || 0) + 1;
        updateDisplay(word);
        celebrateVote(btn);
        lockAllButtons();
        try { localStorage.setItem(votedKey, word); } catch(e) {}

        // then tell the Worker and show the authoritative shared total
        var voteSeed = parseInt(btn.getAttribute('data-icr-seed') || '0', 10);
        fetch(WORKER_URL + '/?word=' + encodeURIComponent(word) + '&seed=' + voteSeed, { method: 'POST' })
          .then(function(r) { return r.json(); })
          .then(function(d) {
            if (d && typeof d.count === 'number') {
              wordCounts[word] = d.count;
              updateDisplay(word);
            }
          })
          .catch(function() {});
      });
    });

    saveCounts();
  }


  /* ══════════════════════════════════════════════════
     CREATOR PICK BADGES + ORDER — Searchanise grid
     ══════════════════════════════════════════════════ */
  (function() {
    var dataEl = document.getElementById('int-creator-pick-data');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var picks = (cfg && cfg.picks) || [];
    if (!picks.length) return;

    var byHandle = {}, order = [];
    picks.forEach(function(p) { if (p && p.handle) { byHandle[p.handle] = p; order.push(p.handle); } });
    if (!order.length) return;

    var CARD_SEL = '.snize-product, .snize-product-list-item, .grid__item, .product-card, .product-grid-item, .sa-card, #sa_grid li';
    var IMG_SEL  = '.snize-thumbnail-wrapper, .snize-thumbnail, .product__image, .card__media';

    function cardHandle(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return null;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }

    var target = document.querySelector('#snize-results, .collection__grid, #sa_grid, main') || document.body;
    var obs;

    function process() {
      var cards = document.querySelectorAll(CARD_SEL);
      if (!cards.length) return;
      if (obs) obs.disconnect();

      /* 1) badge every pick card (current one gets the larger variant) */
      cards.forEach(function(card) {
        var h = cardHandle(card);
        if (!h || !byHandle[h] || card.querySelector('.icr-creator-pick')) return;
        var p = byHandle[h];
        var badge = document.createElement('div');
        /* INT 2026-09-27, approved mockup v6/v7: linen badge, no mint, three lines
           (Word, "by Name" kept together, and on the current pick while the 7 day
           welcome offer truly runs for a visitor from her link, the countdown chip
           on top). window.icrOffer is set by the reveal script in
           creator-collection-story.liquid, which runs during parse, before this file. */
        var io = window.icrOffer;
        var chip = (p.current && io && io.on && io.chip) ? '<span class="icr-cp-off">' + io.chip + '</span>' : '';
        badge.className = 'icr-creator-pick' + (p.current ? ' icr-creator-pick--current' : '') + (chip ? ' icr-creator-pick--offer' : '');
        var avatarHTML = cfg.avatar ? '<img src="' + cfg.avatar + '" alt="" />' : '';
        var nm = String(cfg.creatorName || '').replace(/ /g, '\u00a0');
        var wordHTML = p.word
          ? '<em>' + p.word + '</em>by\u00a0' + nm
          : nm + "'s pick";
        badge.innerHTML = chip + avatarHTML + '<span class="icr-cp-txt">' + wordHTML + '</span>';
        var imgWrap = card.querySelector(IMG_SEL) || card;
        if (getComputedStyle(imgWrap).position === 'static') imgWrap.style.position = 'relative';
        imgWrap.appendChild(badge);
      });

      /* 2) move pick cards to the front, in order (current, last, older…) */
      for (var i = order.length - 1; i >= 0; i--) {
        var hh = order[i], all = document.querySelectorAll(CARD_SEL), match = null;
        for (var j = 0; j < all.length; j++) { if (cardHandle(all[j]) === hh) { match = all[j]; break; } }
        if (match && match.parentNode && match.parentNode.firstElementChild !== match) {
          match.parentNode.insertBefore(match, match.parentNode.firstElementChild);
        }
      }

      if (obs) obs.observe(target, { childList: true, subtree: true });
    }

    obs = new MutationObserver(process);
    obs.observe(target, { childList: true, subtree: true });
    process();
    setTimeout(process, 500);
    setTimeout(process, 1500);
    setTimeout(process, 3000);
  })();
})();

(function(){
  var car = document.querySelector('.icr-hero-carousel');
  if(!car) return;
  var wrap = car.parentElement;
  var dotsWrap = wrap.querySelector('.icr-hero-dots');
  var dots = dotsWrap ? dotsWrap.querySelectorAll('.icr-hero-dot') : [];
  var prev = wrap.querySelector('.icr-hero-arrow--prev');
  var next = wrap.querySelector('.icr-hero-arrow--next');
  function setActive(i){ for(var n=0;n<dots.length;n++){ dots[n].classList.toggle('is-active', n===i); } }
  function current(){ return Math.round(car.scrollLeft / car.clientWidth); }
  function go(i){ var max=car.children.length-1; i=Math.max(0,Math.min(max,i)); car.scrollTo({ left:i*car.clientWidth, behavior:'smooth' }); }
  var raf;
  car.addEventListener('scroll', function(){
    if(raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function(){ setActive(Math.max(0, Math.min(dots.length-1, current()))); });
  }, { passive:true });
  for(var n=0;n<dots.length;n++){ (function(idx){ dots[idx].addEventListener('click', function(){ go(idx); }); })(n); }
  if(prev) prev.addEventListener('click', function(){ go(current()-1); });
  if(next) next.addEventListener('click', function(){ go(current()+1); });
})();
